document.addEventListener('DOMContentLoaded', () => {
  const selects = document.querySelectorAll('.product-info select');
  selects.forEach(select => select.addEventListener('change', () => {
    // Shopify's native product form handles the selected options.
  }));
});